import { getDefaultURLSearchRequest, URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';

import { fetchHotelList, fetchSEOData } from 'store/hotelList/actions';

import { fetchBanner } from 'store/banner/actions';

import { URLSearchQuery } from 'Common-Types';
import { HOTEL_LIST_SORT } from 'constants/sort';
import { universalRouterProps } from 'core/universalRouter/types';
import { RequestBody } from 'HotelList-Types';
import {
  getDefaultURLCustomListRequest,
  getFeatureManagementIds,
  getHotelListValidSortValue,
} from 'utils/search';

const DEFAULT_LIMIT = 30;

export type URLParams = { pageIdentifier: string; map?: string; pageNumber: number };

export default async (
  { store: { dispatch } }: universalRouterProps,
  params: URLParams,
  urlParams: URLSearchQuery,
) => {
  const sortKey =
    urlParams?.[URL_KEYS.SORT] === 'recommended'
      ? HOTEL_LIST_SORT.provider_recommend.value
      : urlParams?.[URL_KEYS.SORT];

  const featureManagementIds = getFeatureManagementIds(urlParams);
  const query: RequestBody = {
    ...getDefaultURLSearchRequest(urlParams),
    ...getDefaultURLCustomListRequest(urlParams),
    accommodationArea: params.pageIdentifier,
    sort: getHotelListValidSortValue(sortKey),
    offset: (params.pageNumber - 1) * DEFAULT_LIMIT,
    limit: DEFAULT_LIMIT,
    latitude: urlParams?.latitude,
    longitude: urlParams?.longitude,
    zoomLevel: urlParams?.zoomLevel,
    featureManagementNames: featureManagementIds,
  };

  await Promise.all([dispatch(fetchBanner()), dispatch(fetchHotelList(query))]);

  return dispatch(fetchSEOData(params.pageNumber));
};
